import React, { Component } from 'react';
import { Link } from 'react-router';
import $ from 'jquery';

export default class Header extends Component {

    componentWillUpdate() {
        $(document).ready(function(){
            $('#dropdown').stop(true, true).slideUp(400);
        });        
    }

    render() {
        return (
            <header id="header" className="tt-nav nav-border-bottom">
                <div className="header-sticky light-header ">
                    <div className="container">
                        <div id="matrox-menu" className="menuzord">
                            <Link to="/" className="logo-brand">
                                <img className="retina" src="/assets/img/logo.png" alt="" />
                            </Link>
                            <ul className="menuzord-menu pull-right">
                                <li className={window.location.pathname === '/' ? 'active' : ''}>
                                    <Link activeClassName="active" to="/">Home</Link>
                                </li>
                                <li className={window.location.pathname === '/about' ? 'active' : ''}>
                                    <Link activeClassName="active" to="/about">Sobre Nós</Link>
                                </li>
                                <li className={window.location.pathname === '/solutions/retail' || window.location.pathname === '/solutions/educational'  ? 'active' : ''}>
                                    <a>Soluções</a>
                                    <ul id="dropdown" className="dropdown">
                                        <li><Link activeClassName="active dropdown-toogle" to="/solutions/educational">Gestão Educacional</Link></li>
                                        <li><Link activeClassName="active dropdown-toogle" to="/solutions/retail">Gestão para Varejo</Link></li>
                                        <li><Link activeClassName="active dropdown-toogle" to="/solutions/custom">Soluções Customizadas</Link></li>
                                    </ul>
                                </li>


                                <li className={window.location.pathname === '/services' ? 'active' : ''}>
                                    <Link activeClassName="active" to="/services">Serviços</Link>
                                </li>
                                <li className={window.location.pathname === '/clients' ? 'active' : ''}>
                                    <Link activeClassName="active" to="/clients">Clientes</Link>
                                </li>
                                <li className={window.location.pathname === '/blog' ? 'active' : ''}>
                                    <Link activeClassName="active" to="/blog">Blog</Link>
                                </li>
                                <li className={window.location.pathname === '/contact' ? 'active' : ''}>
                                    <Link activeClassName="active" to="/contact">Contato</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </header>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/Header.js